import {Popover, PopoverContent, PopoverTrigger} from "../../components/ui/popover";
import {Button} from "../../components/ui/button";
import {ListFilter} from "lucide-react";
import {Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue} from "../../components/ui/select";
import {MonsterType} from "../model/MonsterType";
import {ToggleGroup, ToggleGroupItem} from "../../components/ui/toggle-group";
import {RangeSlider} from "../../components/ui/range-slider";
import {Separator} from "../../components/ui/separator";

export function CharacterFilter({type, setType, hostile, setHostile, min, max, setMinMax, reset, hasFilters}: {
    type: string,
    setType: (value: string) => void,
    hostile: string,
    setHostile: (value: string) => void,
    min: number,
    max: number,
    setMinMax: (min: number, max: number) => void
    reset: () => void
    hasFilters: boolean
}) {
    return <Popover>
        <PopoverTrigger asChild>
            <Button size="icon-sm" variant="outline" className="relative bg-background/30" title="Filtern">
                <ListFilter/>{hasFilters &&
                <span
                    className="absolute top-0.5 right-0.5 size-2 translate-x-2/4 -translate-y-2/4 rounded-full bg-blue-500 "/>
            }
            </Button>
        </PopoverTrigger>
        <PopoverContent align="start" className="flex flex-col gap-2">
            <Select onValueChange={(e) => setType(e || '')} value={type || ""}>
                <SelectTrigger className="w-full" size="sm">
                    <SelectValue placeholder="Monstertyp"/>
                </SelectTrigger>
                <SelectContent>
                    <SelectGroup>
                        <SelectItem key="none" value={undefined!}>-</SelectItem>
                        {MonsterType.map(type =>
                            <SelectItem key={type} value={type}>{type}</SelectItem>)}
                    </SelectGroup>
                </SelectContent>
            </Select>

            <ToggleGroup type="single" size="sm" variant="outline" className="w-full"
                         onValueChange={(e) => setHostile(e || '')} value={hostile || ""}>
                <ToggleGroupItem
                    value="true"
                    className="data-[state=on]:bg-red-600 bg-red-800/30 hover:bg-red-800/50">
                    Feindlich
                </ToggleGroupItem>
                <ToggleGroupItem value="" className="grow">
                    Alle
                </ToggleGroupItem>
                <ToggleGroupItem
                    value="false"
                    className="data-[state=on]:bg-emerald-600 bg-emerald-800/30 hover:bg-emerald-800/50">
                    Verbündet
                </ToggleGroupItem>
            </ToggleGroup>

            <div className="w-full">
                <p className="text-center text-muted-foreground text-sm mb-2">
                    Challenge Rating
                </p>
                <RangeSlider
                    max={30}
                    min={0}
                    step={1}
                    onValueChange={value => setMinMax(value[0], value[1])}
                    value={[min, max]}
                />
            </div>
            <Separator/>
            <div className="flex justify-end">
                <Button size="sm" variant="secondary" onClick={reset}>
                    Filter zurücksetzen
                </Button>
            </div>
        </PopoverContent>
    </Popover>;
}